export default __webpack_public_path__ + "static/logo-e651aa068d77139790200e864f2da6ed.svg";